import {
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  PaperProps,
  Popper,
} from '@mui/material'
import { FC } from 'react'

type Props = {
  menuItems: {
    label: string
    disabled?: boolean
    onClick: () => void
  }[]
  open?: boolean
  placement?: 'bottom-start' | 'bottom-end' | 'top-start' | 'top-end'
  anchorEl?: HTMLElement
  PaperProps?: Partial<PaperProps>
  MenuListProps?: Partial<React.ComponentProps<typeof MenuList>>
  MenuItemProps?: Partial<React.ComponentProps<typeof MenuItem>>
  onClose?: () => void
}
/**
 * 呼び出し元の付近にメニューを表示するコンポーネント
 *
 * @param menuItems メニュー項目情報 { label: 表示文言, disabled: 無効化フラグ, onClick: メニュー項目選択イベント }
 * @param open メニュー表示フラグ
 * @param placement メニュー表示位置
 * @param anchorEl メニュー表示位置の参照
 * @param PaperProps メニューの外枠スタイル
 * @param MenuListProps メニューの内枠スタイル
 * @param MenuItemProps メニューの項目スタイル
 * @param onClose メニュー選択時にメニューを閉じるイベント
 */

export const InlineMenu: FC<Props> = ({
  menuItems,
  placement = 'bottom-start',
  open = false,
  anchorEl,
  PaperProps,
  MenuListProps,
  MenuItemProps,
  onClose,
}) => {
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement={placement}
      transition
      disablePortal
      sx={{
        // Material-UIデフォルトのモーダルのz-indexに合わせる
        zIndex: 1300,
        minWidth: '200px',
        backgroundColor: 'transparent',
        borderRadius: '4px',
      }}
    >
      {({ TransitionProps, placement }) => (
        <Grow {...TransitionProps}>
          <Paper elevation={2} {...PaperProps}>
            <ClickAwayListener
              onClickAway={() => {
                onClose?.()
              }}
            >
              <MenuList
                id="inline-menu"
                aria-labelledby="inline-button"
                sx={{
                  backgroundColor: 'gray.100',
                }}
                {...MenuListProps}
              >
                {menuItems.map(i => (
                  <MenuItem
                    key={i.label}
                    onClick={() => {
                      if (i.onClick) {
                        i.onClick()
                      }
                      onClose?.()
                    }}
                    disabled={i.disabled}
                    {...MenuItemProps}
                  >
                    {i.label}
                  </MenuItem>
                ))}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
}
